// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Button } from '@/components/ui/button';
// import { Card } from '@/components/ui/card';
// import { toast } from 'sonner';
// import { RefreshCw, Pause, Play, Trash2 } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const RecurringSchedules = () => {
//   const [schedules, setSchedules] = useState([]);
//   const [invoices, setInvoices] = useState({});
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchSchedules();
//   }, []);

//   const fetchSchedules = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const response = await axios.get(`${API}/recurring-schedules`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setSchedules(response.data);

//       // Fetch invoice details for each schedule
//       const invoicePromises = response.data.map((schedule) =>
//         axios.get(`${API}/invoices/${schedule.invoice_id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//       );
//       const invoiceResponses = await Promise.all(invoicePromises);
//       const invoicesMap = {};
//       invoiceResponses.forEach((res) => {
//         invoicesMap[res.data.id] = res.data;
//       });
//       setInvoices(invoicesMap);
//     } catch (error) {
//       toast.error('Failed to fetch recurring schedules');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleToggle = async (scheduleId) => {
//     try {
//       const token = localStorage.getItem('token');
//       const response = await axios.patch(
//         `${API}/recurring-schedules/${scheduleId}/toggle`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       toast.success(`Schedule ${response.data.is_active ? 'activated' : 'paused'}`);
//       fetchSchedules();
//     } catch (error) {
//       toast.error('Failed to toggle schedule');
//     }
//   };

//   const handleDelete = async (scheduleId) => {
//     if (!window.confirm('Are you sure you want to delete this recurring schedule?')) return;

//     try {
//       const token = localStorage.getItem('token');
//       await axios.delete(`${API}/recurring-schedules/${scheduleId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       toast.success('Schedule deleted successfully');
//       fetchSchedules();
//     } catch (error) {
//       toast.error('Failed to delete schedule');
//     }
//   };

//   return (
//     <div className="p-8 md:p-12" data-testid="recurring-schedules-page">
//       <h1 className="text-4xl md:text-5xl font-bold mb-12 tracking-tight">Recurring Schedules</h1>

//       {loading ? (
//         <div className="text-muted-foreground">Loading...</div>
//       ) : schedules.length === 0 ? (
//         <Card className="p-12 text-center border-dashed">
//           <RefreshCw className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
//           <p className="text-lg text-muted-foreground mb-4">No recurring schedules yet</p>
//           <p className="text-sm text-muted-foreground mb-6">
//             Create recurring schedules from any invoice detail page
//           </p>
//           <Button onClick={() => navigate('/invoices')} data-testid="go-to-invoices">
//             Go to Invoices
//           </Button>
//         </Card>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {schedules.map((schedule) => {
//             const invoice = invoices[schedule.invoice_id];
//             return (
//               <Card
//                 key={schedule.id}
//                 className={`p-8 hover:shadow-hover transition-all border-border/50 ${
//                   !schedule.is_active ? 'opacity-60' : ''
//                 }`}
//                 data-testid={`schedule-card-${schedule.id}`}
//               >
//                 <div className="flex items-start justify-between mb-4">
//                   <div className="flex items-center gap-3">
//                     <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
//                       schedule.is_active ? 'bg-primary/10' : 'bg-gray-100'
//                     }`}>
//                       <RefreshCw className={`w-6 h-6 ${
//                         schedule.is_active ? 'text-primary' : 'text-gray-400'
//                       }`} />
//                     </div>
//                     <div>
//                       <h3 className="font-bold text-lg">
//                         {invoice ? invoice.invoice_number : 'Loading...'}
//                       </h3>
//                       <span className={`text-xs px-2 py-0.5 rounded-full ${
//                         schedule.is_active
//                           ? 'bg-emerald-100 text-emerald-700'
//                           : 'bg-gray-100 text-gray-600'
//                       }`}>
//                         {schedule.is_active ? 'Active' : 'Paused'}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="space-y-3 text-sm mb-6">
//                   <div className="flex justify-between">
//                     <span className="text-muted-foreground">Frequency:</span>
//                     <span className="font-medium capitalize">{schedule.frequency}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-muted-foreground">Start Date:</span>
//                     <span className="font-medium">{schedule.start_date}</span>
//                   </div>
//                   {schedule.end_date && (
//                     <div className="flex justify-between">
//                       <span className="text-muted-foreground">End Date:</span>
//                       <span className="font-medium">{schedule.end_date}</span>
//                     </div>
//                   )}
//                   <div className="flex justify-between">
//                     <span className="text-muted-foreground">Next Generation:</span>
//                     <span className="font-medium">{schedule.next_generation.split('T')[0]}</span>
//                   </div>
//                   {invoice && (
//                     <div className="flex justify-between pt-2 border-t border-border">
//                       <span className="text-muted-foreground">Amount:</span>
//                       <span className="text-lg font-bold text-primary" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
//                         ${invoice.total.toFixed(2)}
//                       </span>
//                     </div>
//                   )}
//                 </div>

//                 <div className="flex gap-2">
//                   <Button
//                     variant="outline"
//                     size="sm"
//                     onClick={() => handleToggle(schedule.id)}
//                     className="flex-1 gap-2"
//                     data-testid={`toggle-schedule-${schedule.id}`}
//                   >
//                     {schedule.is_active ? (
//                       <>
//                         <Pause className="w-4 h-4" />
//                         Pause
//                       </>
//                     ) : (
//                       <>
//                         <Play className="w-4 h-4" />
//                         Activate
//                       </>
//                     )}
//                   </Button>
//                   <Button
//                     variant="destructive"
//                     size="sm"
//                     onClick={() => handleDelete(schedule.id)}
//                     data-testid={`delete-schedule-${schedule.id}`}
//                   >
//                     <Trash2 className="w-4 h-4" />
//                   </Button>
//                 </div>
//               </Card>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default RecurringSchedules;
import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';
import { RefreshCw, Pause, Play, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { db } from '../firebase';
import {
  collection,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore';


const RecurringSchedules = () => {
  const [schedules, setSchedules] = useState([]);
  const [invoices, setInvoices] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    setLoading(true);
    try {
 

      const snap = await getDocs(collection(db, 'recurringSchedules'));
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setSchedules(list);

      // Fetch invoice details for each schedule
      const invoicesMap = {};
      await Promise.all(
        list.map(async (schedule) => {
          const invoiceId = schedule.invoiceId || schedule.invoice_id;
          if (!invoiceId) return;

          try {
            const invSnap = await getDoc(doc(db, 'invoices', invoiceId));
            if (invSnap.exists()) {
              const inv = { id: invSnap.id, ...invSnap.data() };
              invoicesMap[inv.id] = inv;
            }
          } catch (err) {
            console.error('Failed to fetch invoice for schedule', schedule.id, err);
          }
        })
      );

      setInvoices(invoicesMap);
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch recurring schedules');
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (scheduleId) => {
    try {
      const schedule = schedules.find((s) => s.id === scheduleId);
      if (!schedule) {
        toast.error('Schedule not found');
        return;
      }

      const newActive = !schedule.is_active;
      await updateDoc(doc(db, 'recurringSchedules', scheduleId), {
        is_active: newActive,
      });

      toast.success(`Schedule ${newActive ? 'activated' : 'paused'}`);
      fetchSchedules();
    } catch (error) {
      console.error(error);
      toast.error('Failed to toggle schedule');
    }
  };

  const handleDelete = async (scheduleId) => {
    if (
      !window.confirm(
        'Are you sure you want to delete this recurring schedule?'
      )
    )
      return;

    try {
      await deleteDoc(doc(db, 'recurringSchedules', scheduleId));
      toast.success('Schedule deleted successfully');
      fetchSchedules();
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete schedule');
    }
  };

  return (
    <div className="p-8 md:p-12" data-testid="recurring-schedules-page">
      <h1 className="text-4xl md:text-5xl font-bold mb-12 tracking-tight">
        Recurring Schedules
      </h1>

      {loading ? (
        <div className="text-muted-foreground">Loading...</div>
      ) : schedules.length === 0 ? (
        <Card className="p-12 text-center border-dashed">
          <RefreshCw className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
          <p className="text-lg text-muted-foreground mb-4">
            No recurring schedules yet
          </p>
          <p className="text-sm text-muted-foreground mb-6">
            Create recurring schedules from any invoice detail page
          </p>
          <Button
            onClick={() => navigate('/invoices')}
            data-testid="go-to-invoices"
          >
            Go to Invoices
          </Button>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {schedules.map((schedule) => {
            const invoiceId = schedule.invoiceId || schedule.invoice_id;
            const invoice = invoices[invoiceId];

            const nextGenDate = schedule.next_generation
              ? String(schedule.next_generation).split('T')[0]
              : '-';

            return (
              <Card
                key={schedule.id}
                className={`p-8 hover:shadow-hover transition-all border-border/50 ${
                  !schedule.is_active ? 'opacity-60' : ''
                }`}
                data-testid={`schedule-card-${schedule.id}`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                        schedule.is_active ? 'bg-primary/10' : 'bg-gray-100'
                      }`}
                    >
                      <RefreshCw
                        className={`w-6 h-6 ${
                          schedule.is_active ? 'text-primary' : 'text-gray-400'
                        }`}
                      />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">
                        {invoice ? invoice.invoice_number : 'Loading...'}
                      </h3>
                      <span
                        className={`text-xs px-2 py-0.5 rounded-full ${
                          schedule.is_active
                            ? 'bg-emerald-100 text-emerald-700'
                            : 'bg-gray-100 text-gray-600'
                        }`}
                      >
                        {schedule.is_active ? 'Active' : 'Paused'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="space-y-3 text-sm mb-6">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Frequency:</span>
                    <span className="font-medium capitalize">
                      {schedule.frequency}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Start Date:</span>
                    <span className="font-medium">{schedule.start_date}</span>
                  </div>
                  {schedule.end_date && (
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">End Date:</span>
                      <span className="font-medium">{schedule.end_date}</span>
                    </div>
                  )}
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">
                      Next Generation:
                    </span>
                    <span className="font-medium">{nextGenDate}</span>
                  </div>
                  {invoice && (
                    <div className="flex justify-between pt-2 border-t border-border">
                      <span className="text-muted-foreground">Amount:</span>
                      <span
                        className="text-lg font-bold text-primary"
                        style={{
                          fontFamily: 'JetBrains Mono, monospace',
                        }}
                      >
                        ${Number(invoice.total ?? 0).toFixed(2)}
                      </span>
                    </div>
                  )}
                </div>

                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleToggle(schedule.id)}
                    className="flex-1 gap-2"
                    data-testid={`toggle-schedule-${schedule.id}`}
                  >
                    {schedule.is_active ? (
                      <>
                        <Pause className="w-4 h-4" />
                        Pause
                      </>
                    ) : (
                      <>
                        <Play className="w-4 h-4" />
                        Activate
                      </>
                    )}
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => handleDelete(schedule.id)}
                    data-testid={`delete-schedule-${schedule.id}`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RecurringSchedules;
